import { createTheme } from "@mui/system";

export const theme = createTheme({
    palette:{
        primary:{
            main:"#29b6f6",
            light:"#0288d1"
        },
        secondry:{
            main:'#15c630'
        },
        
    }
})